/**
 * SubscriptionCancel — /subscription/cancel
 *
 * Reached when the user closes the Stripe checkout without paying.
 * Deliberately short and non-judgmental: no "are you sure?" pressure,
 * just a gentle return to pricing or dashboard.
 */
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import BrandMark from "@/components/BrandMark";

export default function SubscriptionCancel() {
    return (
        <div className="grain min-h-screen" data-testid="subscription-cancel-page">
            <Header minimal />
            <main className="max-w-xl mx-auto px-6 pt-24 pb-32 text-center animate-fade-in">
                <div className="flex justify-center mb-10">
                    <BrandMark size={56} />
                </div>
                <p className="label-eyebrow mb-4">Niente è stato addebitato</p>
                <h1 className="h-serif text-4xl md:text-5xl leading-[1.1] mb-8">
                    Hai <span className="italic text-ink-gold">lasciato</span> il checkout.
                </h1>
                <p className="text-ink-textMid text-lg leading-[1.7] mb-10">
                    Non preoccuparti — nessun pagamento è partito. Puoi tornare quando vuoi,
                    oppure continuare a usare Other Side senza abbonamento.
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <Link to="/pricing" className="btn-primary" data-testid="cancel-to-pricing">Vedi di nuovo i piani</Link>
                    <Link to="/dashboard" className="btn-secondary" data-testid="cancel-to-dashboard">Torna al mio spazio</Link>
                </div>
            </main>
        </div>
    );
}
